(() => {
	const swiperContainer = document.querySelectorAll(".bs-personalization-usps__swiper");

	swiperContainer.forEach((swiper) => {
		new Swiper(swiper, {
			slidesPerView: 'auto',
			spaceBetween: 12,
			slidesOffsetBefore: 16,
			slidesOffsetAfter: 16,
			pagination: {
				el: ".bs-personalization-usps__swiper-pagination",
				clickable: true,
			},
		});
	});
})();
